import _get from 'lodash/get';

export default ({ filtersDuck, initialFilters = {}, filtersData = {}, filterGroupsData = {}, queryParams = {} }) => (dispatch, getState) => {
    if (!filtersDuck) {
        throw new Error('setDdpFiltersData requires an instance of a filtersDuck to be passed in');
    }

    const {
        filterGroups = filterGroupsData,
        filters = filtersData,
    } = { filters: filtersData, filterGroups: filterGroupsData };

    dispatch(filtersDuck.creators.setFiltersOptions({
        filters: {
            ...initialFilters,
            ...filters,
        },
        filterGroups,
    }));

    const state = getState();
    const options = filtersDuck.selectors.getFiltersOptions(state);

    if (!options || typeof options !== 'object') {
        dispatch(filtersDuck.creators.setFiltersValues({}));
        return {};
    }

    const values = Object.keys(options).reduce((acc, key) => {
        let value = queryParams[key];

        if (options[key].name) {
            if (queryParams[key]) {
                acc[key] = queryParams[key];
            }
        } else {
            const filter = _get(options, key, {});
            Object.keys(filter).forEach((multiFilterKey) => {
                const filterOptions = _get(filter, [multiFilterKey, 'options'], []);

                value = [].concat(value);

                const filterValues = filterOptions.reduce((_acc, option) => {
                    if (option && option.value && value.includes(option.value)) {
                        _acc.push(option.value);
                    }
                    return _acc;
                }, []);

                if (filterValues.length > 0) {
                    acc[multiFilterKey] = filterValues;
                }
            });
        }
        return acc;
    }, {});

    const yearOptions = _get(options, 'yearRange.options');
    if (!queryParams.endYear && yearOptions && yearOptions.length > 0) {
        values.endYear = yearOptions[yearOptions.length - 1].value;
    }

    dispatch(filtersDuck.creators.setFiltersValues(values));

    return values;
};
